import type * as Types from "../../../graphql/graphql-generated.types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetAppointmentForCancelQueryVariables = Types.Exact<{
  uuid: Types.Scalars["String"]["input"];
}>;

export type GetAppointmentForCancelQuery = {
  __typename?: "Query";
  getAppointmentScheduleItem: {
    __typename?: "AppointmentSchedule";
    uuid: string;
    startTime: string;
    template: string | null;
    series: string | null;
    appointmentType: {
      __typename?: "AppointmentType";
      uuid: string;
      lateCancel: number;
    };
    appointmentCredit: {
      __typename?: "AppointmentCredit";
      uuid: string;
    } | null;
    user: { __typename?: "User"; uuid: string };
  };
};

export type AppointmentForCancelFragment = {
  __typename?: "AppointmentSchedule";
  uuid: string;
  startTime: string;
  template: string | null;
  series: string | null;
  appointmentType: {
    __typename?: "AppointmentType";
    uuid: string;
    lateCancel: number;
  };
  appointmentCredit: { __typename?: "AppointmentCredit"; uuid: string } | null;
  user: { __typename?: "User"; uuid: string };
};

export type GetUserCreditsForCancelQueryVariables = Types.Exact<{
  input: Types.GetUserAppointmentCreditsCountByTypeInput;
}>;

export type GetUserCreditsForCancelQuery = {
  __typename?: "Query";
  getUserAppointmentCreditsCountByType: {
    __typename?: "AppointmentCreditCount";
    count: number;
  };
};

export type DeleteAppointmentTemplateMutationVariables = Types.Exact<{
  input: Types.DeleteAppointmentTemplateInput;
}>;

export type DeleteAppointmentTemplateMutation = {
  __typename?: "Mutation";
  deleteAppointmentTemplate: {
    __typename?: "AppointmentTemplateDeleteResponse";
    deletedAppointments: Array<string>;
  };
};

export const AppointmentForCancelFragmentDoc = gql`
  fragment AppointmentForCancel on AppointmentSchedule {
    uuid
    startTime
    template
    series
    appointmentType {
      uuid
      lateCancel
    }
    appointmentCredit {
      uuid
    }
    user {
      uuid
    }
  }
`;
export const GetAppointmentForCancelDocument = gql`
  query GetAppointmentForCancel($uuid: String!) {
    getAppointmentScheduleItem(uuid: $uuid) {
      ...AppointmentForCancel
    }
  }
  ${AppointmentForCancelFragmentDoc}
`;

/**
 * __useGetAppointmentForCancelQuery__
 *
 * To run a query within a React component, call `useGetAppointmentForCancelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentForCancelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentForCancelQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetAppointmentForCancelQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAppointmentForCancelQuery,
    GetAppointmentForCancelQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAppointmentForCancelQuery,
    GetAppointmentForCancelQueryVariables
  >(GetAppointmentForCancelDocument, options);
}
export function useGetAppointmentForCancelLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAppointmentForCancelQuery,
    GetAppointmentForCancelQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAppointmentForCancelQuery,
    GetAppointmentForCancelQueryVariables
  >(GetAppointmentForCancelDocument, options);
}
export type GetAppointmentForCancelQueryHookResult = ReturnType<
  typeof useGetAppointmentForCancelQuery
>;
export type GetAppointmentForCancelLazyQueryHookResult = ReturnType<
  typeof useGetAppointmentForCancelLazyQuery
>;
export type GetAppointmentForCancelQueryResult = Apollo.QueryResult<
  GetAppointmentForCancelQuery,
  GetAppointmentForCancelQueryVariables
>;
export const GetUserCreditsForCancelDocument = gql`
  query GetUserCreditsForCancel(
    $input: GetUserAppointmentCreditsCountByTypeInput!
  ) {
    getUserAppointmentCreditsCountByType(input: $input) {
      count
    }
  }
`;

/**
 * __useGetUserCreditsForCancelQuery__
 *
 * To run a query within a React component, call `useGetUserCreditsForCancelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCreditsForCancelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCreditsForCancelQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserCreditsForCancelQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUserCreditsForCancelQuery,
    GetUserCreditsForCancelQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUserCreditsForCancelQuery,
    GetUserCreditsForCancelQueryVariables
  >(GetUserCreditsForCancelDocument, options);
}
export function useGetUserCreditsForCancelLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserCreditsForCancelQuery,
    GetUserCreditsForCancelQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUserCreditsForCancelQuery,
    GetUserCreditsForCancelQueryVariables
  >(GetUserCreditsForCancelDocument, options);
}
export type GetUserCreditsForCancelQueryHookResult = ReturnType<
  typeof useGetUserCreditsForCancelQuery
>;
export type GetUserCreditsForCancelLazyQueryHookResult = ReturnType<
  typeof useGetUserCreditsForCancelLazyQuery
>;
export type GetUserCreditsForCancelQueryResult = Apollo.QueryResult<
  GetUserCreditsForCancelQuery,
  GetUserCreditsForCancelQueryVariables
>;
export const DeleteAppointmentTemplateDocument = gql`
  mutation DeleteAppointmentTemplate($input: DeleteAppointmentTemplateInput!) {
    deleteAppointmentTemplate(input: $input) {
      deletedAppointments
    }
  }
`;
export type DeleteAppointmentTemplateMutationFn = Apollo.MutationFunction<
  DeleteAppointmentTemplateMutation,
  DeleteAppointmentTemplateMutationVariables
>;

/**
 * __useDeleteAppointmentTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteAppointmentTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAppointmentTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAppointmentTemplateMutation, { data, loading, error }] = useDeleteAppointmentTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAppointmentTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAppointmentTemplateMutation,
    DeleteAppointmentTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteAppointmentTemplateMutation,
    DeleteAppointmentTemplateMutationVariables
  >(DeleteAppointmentTemplateDocument, options);
}
export type DeleteAppointmentTemplateMutationHookResult = ReturnType<
  typeof useDeleteAppointmentTemplateMutation
>;
export type DeleteAppointmentTemplateMutationResult =
  Apollo.MutationResult<DeleteAppointmentTemplateMutation>;
export type DeleteAppointmentTemplateMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteAppointmentTemplateMutation,
    DeleteAppointmentTemplateMutationVariables
  >;
